<template>
<form :action="formAction" :target="formTarget" method="POST" ref="innerForm"
      :enctype="isMultipart ? 'multipart/form-data': 'application/x-www-form-urlencoded'"
@submit="onSubmit">
  <input v-if="isUpdate" type="hidden" name="_method" value="PUT" />
  <input v-if="isDelete" type="hidden" name="_method" value="DELETE" />
  <input type="hidden" name="_token" :value="$csrfToken" />
  <slot />
</form>
</template>

<script>
export default {
  props: {
    action: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    isDelete: {
      type: Boolean,
      default: false,
    },
    isMultipart: {
      type: Boolean,
      default: false,
    },
    assureToken:{
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      formAction: this.action,
      formTarget: this.target,
    }
  },
  methods: {
    async submit (action = null, target = null) {
      if (action) {
        this.formAction = action
      }
      if (target) {
        this.formTarget = target
      }
      await this.$nextTick()
      this.$refs.innerForm.submit()
    },
    async onSubmit(event){
      if(this.assureToken){
        event.preventDefault()
        if(await this.$checkTokenAge()){
          event.target.submit()
        }
      }
    }
  },
  mounted () {
    if(this.assureToken){
      this.$checkTokenAge()
    }
  },
}
</script>
